import { usePasteConfig, type InputTableColumn } from '@/components/custom/erp';

interface UseDetailItemPasteProps {
  columns: InputTableColumn[];
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (
    configs: Record<string, { resolver: (codes: string[]) => Promise<unknown[]>; resultField?: string }>
  ) => void;
}

export const useDetailItemPaste = ({
  columns,
  handleUpdateNonWritableFields,
  handleUpdatePasteConfigs
}: UseDetailItemPasteProps) => {
  return usePasteConfig({
    columns,
    onNonWritableFields: handleUpdateNonWritableFields,
    onPasteConfigs: handleUpdatePasteConfigs
  });
};
